import { render, staticRenderFns } from "./g-ant-button.vue?vue&type=template&id=3d01f3c3&"
import script from "./g-ant-button.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-ant-button.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports